import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Check, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { fmtMoney } from "@/components/erp";
import api, { errMsg } from "@/lib/api";

const trT = (d) => (d ? d.split("-").reverse().join(".") : "");
const DURUM = { bekliyor: "Yanıtınızı bekliyor", onaylandi: "Onaylandı", itiraz: "İtiraz edildi", iptal: "Geçersiz — yerine yeni mutabakat gönderildi" };

export const MutabakatYanit = ({ m, gonder, acik = true }) => {
  const [ad, setAd] = useState("");
  const [not, setNot] = useState("");
  const [karsi, setKarsi] = useState("");
  const [hata, setHata] = useState("");
  const [busy, setBusy] = useState(false);
  const karar = async (k) => {
    if (ad.trim().length < 2) { setHata("Lütfen adınızı ve soyadınızı yazın"); return; }
    if (k === "itiraz" && !not.trim()) { setHata("İtiraz nedenini yazın"); return; }
    if (!window.confirm(k === "onay" ? "Bakiyeyi onaylıyor musunuz?" : "Bakiyeye itiraz ediyor musunuz?")) return;
    setBusy(true); setHata("");
    try { await gonder({ karar: k, ad, not, karsi_bakiye: karsi }); } catch (e) { setHata(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-3" data-testid={`mutabakat-yanit-${m.no}`}>
      <div className="text-sm">{trT(m.tarih)} itibarıyla bakiyeniz:</div>
      <div className="space-y-1" data-testid="mutabakat-bakiyeler">{Object.entries(m.bakiyeler).map(([pb, v]) => <div key={pb} className="text-lg font-semibold font-mono">{fmtMoney(Math.abs(v), pb)} <span className="text-sm font-normal opacity-70">{Math.abs(v) < 0.005 ? "bakiye yok" : v > 0 ? "borçlusunuz" : "alacaklısınız"}</span></div>)}</div>
      {acik && m.durum === "bekliyor" ? <>
        <Input data-testid="mutabakat-ad" placeholder="Adınız soyadınız *" value={ad} onChange={(e) => setAd(e.target.value)} />
        <Input data-testid="mutabakat-not" placeholder="Not / itiraz nedeni" value={not} onChange={(e) => setNot(e.target.value)} />
        <Input data-testid="mutabakat-karsi" placeholder="Sizin kayıtlarınızdaki bakiye (itirazda)" value={karsi} onChange={(e) => setKarsi(e.target.value)} />
        {hata && <div className="text-sm text-red-500" data-testid="mutabakat-hata">{hata}</div>}
        <div className="flex gap-2">
          <button disabled={busy} data-testid="mutabakat-onayla" onClick={() => karar("onay")} className="inline-flex items-center gap-1.5 px-4 h-10 rounded-lg bg-emerald-600 text-white text-sm font-semibold"><Check className="w-4 h-4" />Onaylıyorum</button>
          <button disabled={busy} data-testid="mutabakat-itiraz" onClick={() => karar("itiraz")} className="inline-flex items-center gap-1.5 px-4 h-10 rounded-lg bg-red-600 text-white text-sm font-semibold"><X className="w-4 h-4" />İtiraz ediyorum</button>
        </div></> : <div className="text-sm font-semibold" data-testid="mutabakat-sonuc">{DURUM[m.durum]}{m.yanit ? ` · ${m.yanit.ad} · ${new Date(m.yanit.tarih).toLocaleString("tr-TR")}` : ""}{m.yanit?.not ? ` · ${m.yanit.not}` : ""}</div>}
    </div>
  );
};

export default function MutabakatOnay() {
  const { token } = useParams();
  const [m, setM] = useState(null);
  const [hata, setHata] = useState("");
  useEffect(() => { api.get(`/acik/mutabakat/${token}`).then((r) => setM(r.data)).catch((e) => setHata(errMsg(e))); }, [token]);
  if (!m) return <div className="min-h-screen bg-neutral-100 flex items-center justify-center p-6 text-sm text-neutral-600" data-testid="mutabakat-sayfa-hata">{hata || "Yükleniyor…"}</div>;
  const logo = m.firma.logo_url;
  return (
    <div className="min-h-screen bg-neutral-100 py-8 px-3 text-neutral-900" data-testid="mutabakat-sayfa">
      <div className="max-w-xl mx-auto rounded-xl bg-white p-6 space-y-4 [&_input]:bg-white [&_input]:border-neutral-300 [&_input]:text-neutral-900">
        <div className="flex items-start justify-between gap-3 border-b pb-3">
          <div><div className="font-semibold">{m.firma.unvan}</div><div className="text-xs text-neutral-500">{m.firma.adres}{m.firma.telefon ? ` · ${m.firma.telefon}` : ""}</div></div>
          {logo && <img src={logo} alt="" className="h-12" />}
        </div>
        <h1 className="text-xl font-semibold">Cari Bakiye Mutabakatı</h1>
        <div className="text-sm text-neutral-600">Belge no: <b>{m.no}</b> · Sayın <b>{m.cari_unvan}</b> ({m.cari_kod})</div>
        {m.mesaj && <p className="text-sm whitespace-pre-line">{m.mesaj}</p>}
        <MutabakatYanit m={m} gonder={async (b) => setM((await api.post(`/acik/mutabakat/${token}/yanit`, b)).data)} />
      </div>
    </div>
  );
}
